<template>
  <v-row dense align="center">
    <v-col cols="12" md="5">
      <v-text-field
        :value="icon.name"
        :label="label"
        placeholder="e.g. mdi:train"
        hide-details="auto"
        dense
        outlined
        @input="update('name', $event)"></v-text-field>
    </v-col>
    <v-col cols="12" md="5">
      <v-text-field
        :value="icon.color"
        :label="`${label} Color`"
        hide-details="auto"
        dense
        outlined
        @input="update('color', $event)"></v-text-field>
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center">
      <v-switch
        :input-value="icon.isCustom"
        color="greeny"
        inset
        label="Is Custom"
        hide-details="auto"
        dense
        class="ma-0 pa-0"
        @change="update('isCustom', $event)"></v-switch>
    </v-col>
  </v-row>
</template>

<script>
export const blankIcon = () => ({ name: "", color: "", isCustom: false });

// The same name / color / custom triple the theme's icon settings use, bound as one object so a
// field that has never had an icon is filled in only once something is typed into it.
export default {
  name: "IconFields",
  props: {
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: "Icon",
    },
  },
  computed: {
    icon() {
      return { ...blankIcon(), ...(this.value || {}) };
    },
  },
  methods: {
    update(field, value) {
      this.$emit("input", { ...this.icon, [field]: field === "isCustom" ? !!value : value });
    },
  },
};
</script>
